import { FormStepResults } from "@redventures/odyssey";

export interface QuizAnswerChoice {
  id: number;
  answer: string;
  value: number;
  userCount?: number;
}

export interface QuizAnswerChoiceVAS {
  id: number;
  answer: string;
  addOn: {
    default: Array<string>;
    5000?: Array<string>;
  };
  userCount?: number;
}

export interface QuizQuestion {
  id: number;
  question: string;
  subtitle?: string;
  answerChoices: QuizAnswerChoice[] | QuizAnswerChoiceVAS[];
  checkbox?: QuizAnswerChoice;
  allowMultiple: boolean;
  isVAS: boolean;
  weight: number;
  additive: number;
}

// Redux
export enum ActionTypes {
  SET_QUIZ = "quiz/set",
  RESET_QUIZ = "quiz/reset",
}

export interface QuizAction {
  type: ActionTypes.SET_QUIZ;
  key: string;
  value: string | number | boolean | FormStepResults;
}

export interface QuizResetAction {
  type: ActionTypes.RESET_QUIZ;
}

export type Actions = QuizAction | QuizResetAction;
